<template>
        <div class="page-inner d-flex align-items-center justify-content-center" style="min-height: 100vh;">
            <div id="main-wrapper" class="h100 d-flex flex-column justify-content-center lead">
              {{ $t('message.Добро_пожаловать_в_панель_управления') }}
            </div>
        </div>
</template>

<script>
    import NavBar from './Nav/NavBar';
    import SideBar from './Nav/SideBar';

    export default {
        name: 'Main',
        components: {
            NavBar,
            SideBar
        },
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Main.vue